var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 50,
    stroke: "#ECFFDB",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 4a2 2 0 100-4v4zm0 96C25.49 100 4 78.51 4 52H0c0 28.719 23.281 52 52 52v-4zM4 52C4 25.49 25.49 4 52 4V0C23.281 0 0 23.281 0 52h4z",
    fill: "url(#crypto-spinner_svg__paint1_linear_2461_16279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crypto-spinner_svg__paint1_linear_2461_16279",
    x1: 27,
    y1: 2,
    x2: 27,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECFFDB"
  })))));
}
export default SvgCryptoSpinner;